<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="overview">
    <div class="item-block" v-for="(item, index) in showData" :key="index">
      <div class="item">
        <div class="icon" v-html="item.icon"></div>
        <div>
          <span v-if="item.name">{{ item.name }}：</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});
</script>
<style lang="scss" scoped>
@import './index.scss';
.item-block {
  padding: 18px 0;
  margin: 0 100px;
}
.item {
  display: flex;
  align-items: center;
  padding: 12px 32px;
  min-height: 60px;
  border: 1px solid #cbcbcb;
  font-size: 16px;
  color: #3e3e3e;
  .icon {
    margin-right: 12px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
}
</style>
